import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import { XIcon } from '@heroicons/react/solid'

const UploadImage = ({ icon, text, setFile, file, onRemove }) => {
    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles?.length > 0) {
            setFile(acceptedFiles[0])
        }
    })

    const srcImage = (file && URL.createObjectURL(file)) || null

    const dropZoneOptions = {
        onDrop,
        maxSize: '10485760', // 10 mb
        accept: {
            'image/jpeg': [],
            'image/png': [],
        },
        multiple: false,
    }

    const { getRootProps, getInputProps } = useDropzone({
        ...dropZoneOptions,
    })

    return (
        <div className="w-full flex-grow border h-40 cursor-pointer border-grayLines rounded-3xl overflow-visible flex flex-col items-center justify-center relative">
            {file && (
                <div
                    onClick={onRemove}
                    role="button"
                    className="w-6 h-6 flex items-center justify-center rounded-full bg-error cursor-pointer  absolute -top-1 -right-1"
                >
                    <XIcon className="text-white w-4 h-4" />
                </div>
            )}
            <div
                {...getRootProps()}
                className="w-full h-full flex items-center flex-col justify-center rounded-3xl overflow-hidden  gap-y-4"
            >
                {!file && icon}
                {!file && (
                    <p className="font-normal text-base text-textDarkerGray">
                        {text}
                    </p>
                )}
                {file && (
                    <img
                        className="object-cover w-full h-full"
                        src={srcImage}
                    />
                )}
            </div>
            <input
                {...getInputProps()}
                type="file"
                aria-label="Dropzone File"
                id="uploadFile"
                name={name}
                className="hidden"
            />
        </div>
    )
}

UploadImage.propTypes = {
    setFile: PropTypes.func,
    file: PropTypes.object,
    icon: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.element,
        PropTypes.string,
    ]),
    text: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
    onRemove: PropTypes.func,
}

export default UploadImage
